import React from 'react';

import Support from '../../../shared/Support';
import approved from '../../../../images/approved_text.svg';
import checkmark from '../../../../images/green_checkmark.svg';
import { borrowerPortalUrl } from '../../../../constants/SiteVariables';

export default function Default({ merchant }) {
  return (
    <>
      <div className="is-size-4 has-text-weight-bold">
        You're good to go!
      </div>
      <p className="mt-1  mb-3" style={{ color: "#7A899A" }}>
        We told you it would be easy
      </p>
      <div className="mt-3">
        <img
          alt="Green Checkmark"
          src={checkmark}
        />
      </div>
      <div className="mt-3 mb-3">
        <img
          alt="Approved Text"
          src={approved}
        />
      </div>
      <div className="columns">
        <div className="column is-centered">
          <div style={{ maxWidth: "400px", margin: "0 auto", lineHeight: "30px", marginBottom: "30px" }}>
            <p>Simply choose <span className="has-text-weight-semibold">Credit Key</span> at checkout.</p>
            <p>Access your account at <a className="has-text-weight-semibold" style={{ color: "#3273dc" }} target="_blank" href={borrowerPortalUrl()} rel="noreferrer">www.creditkey.com</a></p>
          </div>

          <Support />
        </div>
      </div>
    </>
  );
}
